<template>
	<div class="menu-comp">
		<div class="menu-wrap">
			<div class="logo-image flex-center" v-if="logo">
				<div class="image-dom border-radius-filled" :style="{ backgroundImage: `url(${logo})` }"></div>
			</div>
			<div
				class="menu-list"
				:style="{
					'--maincolor': mainColor,
					'--bgcolor': calcBgColor
				}"
			>
				<div
					class="menu-item"
					v-for="(item, index) in menuList"
					:key="index"
					@click="$route.path != `/nav/${item.path}` && $router.replace({ path: `/nav/${item.path}` })"
				>
					<div class="set-wrap" v-if="item.permissionId === 'seting'">
						<div class="icon-wrap"><i class="el-icon-setting"></i></div>
					</div>
					<div
						v-else
						class="menu-btn flex-center"
						:class="[$route.path === `/nav/${item.path}` ? 'active' : '']"
					>
						<div class="menu-text">{{ item.name }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="main-wrap">
			<keep-alive><router-view v-if="$route.meta.keepAlive"></router-view></keep-alive>
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex';

import * as constants from '@/tools/constants.js';

import * as utils from '@/tools/utils.js';
export default {
	data() {
		return {};
	},
	computed: {
		...mapState({
			logo: store => store.logo,
			mainColor: store => store.mainColor
		}),
		// 主题色颜色减轻色值
		calcBgColor() {
			return utils.hex2RgbaFn(this.mainColor, 0.1);
		},
		// 菜单列表数据
		menuList() {
			return constants.menuList.filter(i => this.$store.state.permissionListDatas.includes(i.permissionId));
		}
	}
};
</script>
<style scoped lang="less">
.menu-comp {
	display: flex;
	height: 100vh;
	.menu-wrap {
		display: flex;
		flex-direction: column;
		width: 80px;
		height: 100%;
		background: #f4f6f7;

		.logo-image {
			width: 72px;
			height: 72px;
			background: #ffffff;
			font-size: 0;

			.image-dom {
				width: 60px;
				height: 60px;
				background-size: contain;
				background-position: center;
				background-repeat: no-repeat;
				overflow: hidden;
			}
		}

		.menu-list {
			flex: 1;
			overflow: hidden;
			width: 72px;
			background: #ffffff;
			position: relative;

			.menu-item {
				.menu-btn {
					position: relative;
					box-sizing: border-box;
					min-height: 72px;
					padding: 4px;
					cursor: pointer;
					.menu-text {
						font-size: 16px;
						color: #303133;
					}
					&:hover {
						background: var(--bgcolor);
					}
					&:after {
						display: none;
						content: '';
						width: 3px;
						background: var(--maincolor);
						position: absolute;
						right: 0;
						top: 0;
						bottom: 0;
					}
					&.active {
						font-weight: bold;
						background: var(--bgcolor);

						&:after {
							display: block;
						}
						.menu-text {
							color: var(--maincolor);
						}
					}
				}

				.set-wrap {
					position: absolute;
					left: 50%;
					transform: translateX(-50%);
					bottom: 34px;
					cursor: pointer;
					.icon-wrap {
						i {
							font-size: 20px;
							color: #000000;
						}
					}
				}
			}
		}
	}
	.main-wrap {
		min-height: 100%;
		flex: 1;
		overflow: hidden;
	}
}
</style>



// WEBPACK FOOTER //
// src/app-components/menu-comp/menu-comp.vue